import React from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  color?: 'blue' | 'green' | 'red';
}

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, label, disabled, className = "", color = 'blue' }) => {
  const colorClasses = {
    blue: checked ? "bg-blue-600" : "bg-gray-300",
    green: checked ? "bg-green-600" : "bg-gray-300",
    red: checked ? "bg-red-600" : "bg-gray-300",
  };

  const focusRingClasses = {
    blue: "focus:ring-blue-500",
    green: "focus:ring-green-500",
    red: "focus:ring-red-500",
  };

  return (
    <label className={`inline-flex items-center gap-3 ${disabled ? "opacity-60" : ""} ${className}`}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label || "switch"}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={[
          "relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out",
          colorClasses[color],
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
          `focus:outline-none focus:ring-2 ${focusRingClasses[color]} focus:ring-offset-2`,
        ].join(" ")}
        style={{
          backgroundColor: checked 
            ? (color === 'green' ? '#16a34a' : color === 'red' ? '#dc2626' : undefined)
            : undefined
        }}
      >
        <span
          className={[
            "inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out shadow-md",
            checked ? "translate-x-6" : "translate-x-1",
          ].join(" ")}
        />
      </button>
      {label && <span className="text-sm text-gray-700">{label}</span>}
    </label>
  );
};

